/**
 * Main JavaScript file for the WordPres theme
 *
 * This file gets loaded for all users.
 *
 * @license		No license
 * (Without a license, the code is copyrighted by default.
 * People can read the code, but they have no legal right to use
 * it. To use the code, you must contact the author directly and
 * ask permission.)
 *
 * @author		Velten Media
 * @link		http://www.veltenmedia.nl
 * @email		info@veltenmedia.nl
 *
 * @file		main.js
 *
 * @copyright	(C) 2015, Velten Media
 */

import Cookies from 'js-cookie'



 jQuery(document).resize(function () {
    var screen = $(window)
    if (screen.width() < 767) {
        $(".brochure-slider .first").hide();
    }
    else {
        $(".brochure-slider .first").show();
    }
});

jQuery(document).ready(function($){

	var isMobile = false;

	function resizer() {
	    var w = $(window).width();
	    if (w < 768) {
	        $(".brochure-slider .first").hide();
	        isMobile = true;
	    } else {
		    $(".brochure-slider .first").show();
	        isMobile = false;
	    }
	}

	$(window).on('load resize', function(){
	    resizer();
	});

	// Load on input and textarea elements if
	// the jQuery Placeholder plugin is loaded
	if($.isFunction($.fn.placeholder)){
		;
	}

/*
	if ($('body').hasClass('home')) {
		$('.top-right nav ul li:first-child').addClass('active');
		$('.top-right nav ul li:last-child').removeClass('active');
	} else if ($('body').hasClass('page-template-page-zakelijk')) {
		$('.top-right nav ul li:first-child').removeClass('active');
		$('.top-right nav ul li:last-child').addClass('active');
	}
*/

/*
	if ($('body').hasId('zakelijk'))) {
		$('.top-right nav ul li:first-child').removeClass('active');
		$('.top-right nav ul li:last-child').addClass('active');
	} else {
		$('.top-right nav ul li:first-child').addClass('active');
		$('.top-right nav ul li:last-child').removeClass('active');
	}
*/


	//Home bg-slider
	$('.bg-slider').slick({
		fade: true,
		speed: 800,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
	});

	$('.project-slider').slick({
		fade: false,
		speed: 800,
		arrows: true,
		prevArrow: $('.slider-arrows__prev'),
		nextArrow: $('.slider-arrows__next'),
		autoplay: false,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		slidesToShow: 2,
		infinite: false,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1.1,
					slidesToScroll: 1,
				}
			}
		]
	});

	$('.references__slider').slick({
		fade: true,
		speed: 800,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
	});

	$('.content-slider').slick({
		fade: false,
		speed: 800,
		arrows: false,
		dots: true,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		asNavFor: '.bg-slider',
		customPaging : function(slider, i) {
	        var title = $(slider.$slides[i]).data('title');
	        var subtitle = $(slider.$slides[i]).data('subtitle');
	        var date = $(slider.$slides[i]).data('date');
// 	        return '<div class="inner"><p>'+title+'</p><p class="subtitel">'+subtitle+'</p><p class="date">'+date+'</p></div>';
	        return '<div class="inner"><p>'+title+'</p><p class="date">'+date+'</p></div>';
	    },
	});

	//Home ref-slider
	$('.ref-quotes-slider').slick({
		fade: true,
		speed: 1200,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 8000,
		pauseOnHover: false,
	});

	//Flexible content slider
	$('.image-slider__slick').slick({
		fade: false,
		speed: 800,
		arrows: true,
		dots: true,
		autoplay: false,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		infinite: true,
	});

	$( "p.subtitel:contains('undefined')" ).addClass('none');
	$( "p.date:contains('undefined')" ).addClass('none');

	//Side navigation
/*
	$('.side-nav-trigger').on('click', function() {
		$('.side-nav-outer').addClass('open');
		$('body').addClass('open');
	});

	$('.side-close-trigger').on('click', function() {
		$('.side-nav-outer').removeClass('open');
		$('body').removeClass('open');
	});
*/

/*
	$(document).on('mousedown touchstart', function (e)
	{
	    var container = $(".side-nav-container");

	    if (!container.is(e.target) && container.has(e.target).length === 0)
	    {
	      $('.side-nav-outer').removeClass('open');
	      $('body').removeClass('open');
	    }
	});
*/



	$('select').parent().addClass('select-parent');

	$('body.post-type-archive-referentie .menu-zijmenu-container .menu-item-360').addClass('current-menu-item');
	$('body.tax-provincie .menu-zijmenu-container .menu-item-360').addClass('current-menu-item');
	$('body.single-referentie .menu-zijmenu-container .menu-item-360').addClass('current-menu-item');


	//Search
	$('.search-trigger').on('click', function () {
		$('header').toggleClass('search-open');

		if ($('.header').hasClass('search-open')) {
		    $('.search-form-wrapper .search-input').focus();
		} else {
		    $('.search-form-wrapper .search-input').blur();
		}
	});

	$('.close-search').on('click', function () {
		$('header').removeClass('search-open');
		$('.search-form-wrapper .search-input').blur();
	});

	//Mobile navigation
	$('header .bottom > nav > ul > li').on('click',function() {
		var $this_all = $('header .bottom > nav > ul > li'),clickNum = $this_all.data('clickNum');
		var $this = $(this);
		var submenu = $(this).find('> .sub-menu');
		var submenu_open = $(this).find('> .sub-menu.submenu-open');

		if (!clickNum) clickNum = 1;

	    if (clickNum == 1) {
		   $(submenu).addClass('sub-menu-open');
		   $($this).addClass('main-open');
		   $this_all.data('clickNum', ++clickNum);
		   console.log(clickNum);
	    } else {
		    setTimeout(function(){
				$(submenu).addClass('sub-menu-open');
				$($this).addClass('main-open');
			}, 500);
	    }

		$('header .bottom > nav > ul > li').not($this).removeClass('main-open');
		$('header .bottom > nav > ul > li > .sub-menu').not(submenu).removeClass('sub-menu-open');
		$(submenu_open).removeClass('sub-menu-open');
	});

	$('header .bottom > nav > ul > li > .sub-menu > li').on('click',function() {
		var $this_all = $('header .bottom > nav > ul > li > .sub-menu > li'),clickNum = $this_all.data('clickNum');
		var $this = $(this);
		var submenu = $(this).find('.sub-menu');
		var submenu_open = $(this).find('.sub-menu.submenu-open');

		if (!clickNum) clickNum = 1;

	    if (clickNum == 1) {
		   $(submenu).addClass('sub-menu-open');
		   $($this).addClass('main-open');
		   $this_all.data('clickNum', ++clickNum);
		   console.log(clickNum);
	    } else {
		    setTimeout(function(){
				$(submenu).addClass('sub-menu-open');
				$($this).addClass('main-open');
			}, 500);
	    }

/*
		$('header .bottom > nav > ul > li > .sub-menu > li').not($this).removeClass('main-open');
		$('.sub-menu').not(submenu).removeClass('sub-menu-open');
		$(submenu_open).removeClass('sub-menu-open');
*/
	});

	$('.nav-trigger').on('click', function() {
		$(this).toggleClass('nav-trigger-open');
		$('.nav-container').toggleClass('nav-open');
		$('body').toggleClass('open');
	});

	//Onze partners slider
	$('.our-partners ul').slick({
		fade: false,
		arrows: true,
		speed: 800,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
	    {
	      breakpoint: 640,
	      settings: {
	        slidesToShow: 3,
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 2,
	      }
	    }]
	});


	$('.label-radio input').on('click', function() {
		var parent = $(this).parent();
		$('.label-radio').not(this).removeClass('active');
		$(parent).addClass('active');

	});

	const $slick_slider = $('.usp-inner ul');

	if ($(window).width() < 768) {

		$slick_slider.slick({
			fade: false,
			arrows: false,
			dot: false,
			speed: 800,
			autoplay: true,
			autoplaySpeed: 3000,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 960,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}

	//Verplichte velden WPCF7
	$('input.wpcf7-validates-as-required').parent().addClass('required');
	$('textarea.wpcf7-validates-as-required').parent().addClass('required');
	$('select.wpcf7-validates-as-required').parent().addClass('required');

	$('.radio label').on('click', function(){
		$(this).parent().parent().find('.radio').find('label').removeClass('active');
		var input = $(this).find("input[type='radio']");
		if(input){
			if(input.is(":checked")){
				$(this).addClass('active');
			}
		}
	});

	$("input[type=checkbox]").on('change', function () {
	    $(this).parent().toggleClass("active");
	});

/*
	$('body').on('click', function() {
		$('.step-3').toggleClass('show');
	});
*/

	// Add green checks if certain required inputs are not empty
	$('input[type=text].wpcf7-validates-as-required, input[type=number].wpcf7-validates-as-required, .step-1 input[name="step_1_zipcode"], .step-1 input[name="step_1_house_number"], .step-5 input[name="step_5_last_name"], .step-5 input[name="step_5_phone"]').change(function() {
		var inputValue = $(this).val();
		if (inputValue != null && inputValue != '') {
			$(this).parent().addClass('checked-green');
		} else {
			$(this).parent().removeClass('checked-green');
		}
	});

	// Validate email input
	function validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	$('input[type=email].wpcf7-validates-as-required, .step-5 input[name="step_5_email"]').change(function() {
		var inputValue = $(this).val();
		if (validateEmail(inputValue) == true) {
			$(this).parent().addClass('checked-green');
		} else {
			$(this).parent().removeClass('checked-green');
		}
	});

	$('.brochure-slider').slick({
		fade: false,
		speed: 800,
		arrows: true,
		autoplay: false,
		slidesToShow: 2,
		slidesToScroll: 2,
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});



	$('button[type="reset"]').on('click', function() {
		$('.filter-container label').removeClass('active');
	});

	$('.filter-wrapper p').click(function(){
        $('.filter-wrapper p').toggleClass('active');
        $('.filter-slide').slideToggle(400);
    });

	if( $(window).width() <= 1024 ) {

		$(".menu-item-has-children").one("click", function(e) {
			e.preventDefault();
		});
	}

	if( $(window).width() <= 1023 ) {

		$('#menu-topmenu-rechts li').detach().appendTo('#menu-zijmenu');
	}

	const urlParams = new URLSearchParams(window.location.search);
	const inputParam = urlParams.get('form-input');

	if(window.location.href.indexOf("form-input") > -1) {

		let existingValues = [];

		$(".wpcf7-form input[type=checkbox]").each(function() {
			let checkbox = ('input:checkbox[value="' + inputParam + '"]');

			let checkboxValue = $(this).val();

			existingValues.push(checkboxValue);

			if ($(checkbox)) {
				$(checkbox).parent().addClass('active');
				$(checkbox).prop('checked', true);
			}
		});

		if (existingValues.includes(inputParam) === false) {
			let checkboxElse = ('input:checkbox[value="Anders"]');
			$(checkboxElse).prop('checked', true);
		}

	}

	$('.advice-popup__close').on('click', function () {
		Cookies.set('advice_popup', 'true', { expires: 7 });
		$('.advice-popup').removeClass('advice-popup--show');
		setTimeout(function(){
			$('.advice-popup').css('display', 'none');
		}, 300);
	});

	if( $(window).width() > 991 ) {

		if (Cookies('advice_popup') != 'true') {

			$(window).scroll(function () {
				var scroll = $(window).scrollTop();
				if (scroll >= 750) {
					$('.advice-popup').addClass('advice-popup--show');
				} else {
					$('.advice-popup').removeClass('advice-popup--show');
				}
			});
		}
	} else {

		if (Cookies('advice_popup') != 'true') {

			$(window).scroll(function () {
				var scroll = $(window).scrollTop();
				if (scroll >= 300) {
					$('.advice-popup-mobile').addClass('advice-popup-mobile--show');
				} else {
					$('.advice-popup-mobile').removeClass('advice-popup-mobile--show');
				}
			});
		}

		$('.advice-popup-mobile').on('click', function () {
			Cookies.set('advice_popup', 'true', { expires: 7 });
		});
	}


});
